var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhte({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5827 6C15.2493 5.66667 14.7493 5.66667 14.416 6L8.16602 12.25L5.58268 9.66667C5.24935 9.33333 4.74935 9.33333 4.41602 9.66667C4.08268 10 4.08268 10.5 4.41602 10.8333L7.58268 14C7.74935 14.1667 7.91602 14.25 8.16602 14.25C8.41602 14.25 8.58268 14.1667 8.74935 14L15.5827 7.16667C15.916 6.83333 15.916 6.33333 15.5827 6Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhte);
export default __webpack_public_path__ + "static/media/check-whte.7c19b239f2f91264c3abea93d8533937.svg";
export { ForwardRef as ReactComponent };